import React from 'react';
import { motion } from 'framer-motion';
import { CircleXIcon } from 'lucide-react';
const painPoints = [['Constant Class Planning', 'You spend hours every week creating routines and class structures that are safe, engaging, and appropriate for different levels.'], ['The Fear of Going Too Hard... or Too Easy', 'You wonder whether a combination is too complex, repetitive, or simply not right for the group in front of you.'], ['Information Everywhere — But No Real System', 'Ideas are scattered across YouTube, Instagram, and online courses — but nothing is organized into one complete teaching system.'], ['Mental Exhaustion Before You Even Step Into the Room', 'Between choreography, warm-ups, music, progressions, and motivation, there is barely energy left for delivering a great class.']];
export function PainPoints() {
  return <section className="bg-navy px-4 py-20 text-white sm:py-24" data-id="element-151">
      <div className="mx-auto max-w-3xl" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-153">
          <h2 className="font-display text-3xl font-bold sm:text-4xl" data-id="element-154">
            Do any of these sound familiar?
          </h2>
          <p className="mt-5 text-base leading-relaxed text-slate-200" data-id="element-155">
            You love teaching dance fitness — but does class preparation consume
            your entire week?
          </p>
          <p className="mt-7 rounded-2xl border border-white/15 bg-navy-dark p-6 text-left text-base leading-relaxed text-slate-100" data-id="element-156">
            Whether you are already teaching or just starting out, building
            professional classes from day one should not mean starting over
            every single week.
          </p>
        </motion.div>

        <div className="mt-10 space-y-3" data-id="element-157">
          {painPoints.map(([title, description], index) => <motion.article key={title} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.07
        }} className="flex gap-3 rounded-xl border border-white/15 bg-white/5 p-5" data-id="element-158">
              <CircleXIcon className="mt-0.5 shrink-0 text-orange" size={18} data-id="element-159" />
              <div data-id="element-160">
                <h3 className="font-semibold text-white" data-id="element-161">{title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-slate-200" data-id="element-162">
                  {description}
                </p>
              </div>
            </motion.article>)}
        </div>

        <div className="mt-12 border-t border-white/20 pt-9 text-center" data-id="element-163">
          <p className="font-display text-2xl font-bold text-orange" data-id="element-164">
            Stop creating classes from scratch. What you need is a real system.
          </p>
          <p className="mt-3 text-lg text-white" data-id="element-165">
            Teach with structure and confidence from minute one.
          </p>
        </div>
      </div>
    </section>;
}